import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "addCustomCapabilityLink",
    "customCapabilitiesItemTemplate",
    "customCapabilitiesList",
  ];

  addCustomCapability(event) {
    event.preventDefault();

    const customCapabilityItemTemplate = this.customCapabilitiesItemTemplateTarget;
    const newCustomCapabilityItem = customCapabilityItemTemplate
      .querySelector(".custom-capability-item-wrapper")
      .cloneNode(true);

    this.customCapabilitiesListTarget.appendChild(newCustomCapabilityItem);
  }

  removeCustomCapability(event) {
    event.preventDefault();

    const customCapabilityItem = event.currentTarget.closest(".custom-capability-item-wrapper");
    const hiddenField = customCapabilityItem.querySelector(".destroy-hidden-field");

    if (hiddenField) {
      hiddenField.value = "true";
      customCapabilityItem.style.display = "none";
    } else {
      customCapabilityItem.remove();
    }
  }
}
